// export this package's api
import Drawer from './Drawer';

export default Drawer;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/node_modules/rc-drawer/es/index.js
// module id = null
// module chunks = 